import type { CSSProperties } from 'react';
import type { LayoutInlineStyle } from './types';

export function layoutInlineStyle(
  s: LayoutInlineStyle | undefined
): CSSProperties | undefined {
  if (s == null || Object.keys(s).length === 0) return undefined;
  return s as CSSProperties;
}
